/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: authoring-common
 * (C) Copyright IBM Corp. 2020, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const View = require('lib/@waca/core-client/js/core-client/ui/core/View');
import React from 'react';
import ReactDOM from 'react-dom';
import PaletteListingWrapper from '../components/paletteListing/PaletteListingWrapper';
import CustomPalette from 'dialog/CustomPalette';

const PaletteListingView = View.extend({
	init: function (options, container) {
		PaletteListingView.inherited('init', this, arguments);
		this.container = container;
		this.options = options;
	},
	render: function () {
		ReactDOM.render( (
			<PaletteListingWrapper
				paletteService={this.options.paletteService}
				getPalettes={this.options.getPalettes}
				createPalette={this._openPaletteCreator.bind(this)}
				onChange={this.options.onChange}
				mruComponentIdentifier={this.options.mruComponentIdentifier}
				selectedId={this.options.selectedId}
				createPaletteType={this.options.createPaletteType}
				onClose={this.options.slideout.hide.bind(this.options.slideout)}
			/>
		), this.container );
	},
	remove: function () {
		ReactDOM.unmountComponentAtNode( this.container );
	},
	_openPaletteCreator: function () {
		let paletteComponent = <CustomPalette
			key='addNewPalette'
			paletteService={this.options.paletteService}
			onPaletteCreated={this.options.onCreatePalette.bind(this)}
			paletteType={this.options.createPaletteType}
			removeDialog={() => {
				const paletteContainer = document.querySelector('.paletteDialogContainer');
				ReactDOM.unmountComponentAtNode( paletteContainer );
			}}
			ref={(instance) => {
				this.palleteDialog = instance;
			}}>
		</CustomPalette>;
		let paletteContainer = document.querySelector('.paletteDialogContainer');
		if (!paletteContainer) {
			paletteContainer = document.createElement('div');
			paletteContainer.classList.add('paletteDialogContainer');
			document.body.append(paletteContainer);
		}
		ReactDOM.render(paletteComponent, paletteContainer);
		this.palleteDialog.openDialog();
	}
});

export default PaletteListingView;



// WEBPACK FOOTER //
// ./src/js/views/PaletteListingView.js